import { ToolsService } from "./../../services/migrate/tools.service";
import { CoreService } from "./../../services/migrate/api.core.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { USER_DATA } from "../../utils/constants.util";
import {
  FIELDS,
  NO_SELECTED_COMPANY,
  VHEICLE_WITHOUT_TERMINAL_NOT_FOUND_MSG,
} from "./constants.terminal";
import Swal from "sweetalert2";

import { ApiService } from "../../services/api.service";
import { Validation } from "./validation";
import { FormateDate } from "src/app/utils/date/formateDate";
import { STORAGE_KEY_ID_PERFIL } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import { Company } from "src/app/models/Company.model";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { TrackerModelService } from "../../services/tracker-model.service";
import { TrackerModel } from "../../models/tracker-model";
import { PageEvent } from "@angular/material/paginator";
import { TrackerModelPaginated } from "../../models/tracker-model-paginated";
import { toCamel } from "snake-camel";

export class TerminalCore {
  private readonly ISTARTEK_MODEL_NAMES = new Set<string>([
    "STR-1010",
    "STR-1010+",
    "STR-200",
    "STR-600P",
  ]);

  public apiBaseService: ApiBaseService;
  public activedView = false;
  public activedClone = false;
  public activedEdit = false;
  public swal = true;

  public titleVar = "";

  public terminalForm: FormGroup;
  public validation: Validation;
  public serviceCore: CoreService;
  public service: ApiService;

  public terminal: any;
  public terminalId: any;
  public idVeiculo: any;

  public terminalProtocoloSelected: any;
  public empresaSelected: any;
  public empresaFilterSelected;
  public empresaSelectedEdit: any;
  public veiculoSelected: number;
  public errorMessage;

  public companys = new Array<any>();
  public terminalProtocols = new Array<any>();
  public terminalIcons = new Array<any>();
  public vehicles = new Array<any>();
  public vehiclesEdit = new Array<any>();
  public companiesFilter: any = [];
  public companiesSelect: any = [];

  public vehiclesForm = new Array<any>(NO_SELECTED_COMPANY);
  public records = new Array<any>();

  public envioLote = true;
  public cond = true;
  public compLote = 0;
  public tmp = 0;
  public nomeArq: string = "";
  public btnText = "Processar";
  public btnDisabled = false;
  public cadsituacao = 0;

  public trackerModelService: TrackerModelService;
  public trackerModelsPaginated: TrackerModelPaginated;
  public trackerModelSelected: TrackerModel;
  public filteredVehicles: any[] = [];
  public selectedPlate: any;   // Objeto selecionado para exibir na entrada


  constructor(
    apiserviceCore: CoreService,
    apiService: ApiService,
    formBuilder: FormBuilder,
    public tools: ToolsService /*   private doenload_cvs: DownloadCsv, */,
    baseService: ApiBaseService,
    trackerModelService: TrackerModelService
  ) {
    this.serviceCore = apiserviceCore;
    this.service = apiService;
    this.validation = new Validation();
    this.apiBaseService = baseService;
    this.trackerModelService = trackerModelService;
  }

  /* API */

  public async loadDataElements() {
    try {
      this.tools.builder().spinner.show();

      const params = {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      };

      const result = await this.apiBaseService.get<any>({
        url: new Company()["nomeConsultaApiBaseGetAll"],
        params,
      });

      //const terminalProtocolos = await this.service.get<any>({
      //  url: "terminal-protocolo",
      //});

      this.trackerModelService.getAll().subscribe((t) => {
        this.trackerModelsPaginated = toCamel(t) as TrackerModelPaginated;
      });

      const vehicles: any = await this.apiBaseService.get<any>({
        url: "veiculos/getAllWithoutTerminal",
      });

      this.vehiclesForm = vehicles["content"];
      this.filteredVehicles = vehicles["content"];
      this.vehicles = vehicles["content"];
      this.vehiclesEdit = vehicles["content"];
      this.companys = result["content"];
      //this.terminalProtocols = terminalProtocolos.content;

      this.verifyIfLoadTerminalById();

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.tools.builder().spinner.hide();
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadTerminal(id): Promise<void> {
    try {
      this.tools.builder().spinner.show();
      const response = await this.serviceCore.get<any>({
        url: `v2/terminals/${id}`,
      });

      const vehiclesEdit: any = await this.apiBaseService.get<any>({
        url: `veiculos/${response.idVeiculo}`,
      });

      const vehicles: any = await this.apiBaseService.get<any>({
        url: "veiculos/getAllWithoutTerminal",
        params: {
          idEmpresa: response.idEmpresa,
        },
      });

      this.terminal = response;
      this.vehicles = vehicles;
      this.vehiclesForm = vehicles;
      this.filteredVehicles = vehicles;

      console.log(this.terminal);

      this.companys.forEach((element) => {
        if (element.id == this.terminal.idEmpresa) {
          if (element.cnpj == null) {
            this.titleVar = "Divisão";
          }

          if (element.cnpj != null && element.idEmpresaMatriz == null) {
            this.titleVar = "Matriz";
          }

          if (element.cnpj != null && element.idEmpresaMatriz != null) {
            this.titleVar = "Filial";
          }
        }
      });

      this.vehiclesForm.push(vehiclesEdit);

      console.log(this.vehiclesForm);

      if (this.vehicles.length != 0) {
        this.vehicles.forEach((veiculos) => {
          if (veiculos.id == this.terminal.idVeiculo) {
            this.veiculoSelected = veiculos;
          }
        });
      } else {
        this.msgSwalWarningEdit();
      }

      if (this.terminal != null) {
        console.log("PASSEI TERMINAL EXISTENTE");
        console.log(this.terminal);

        // Se o terminal existir, defina veiculoSelected com o idVeiculo do terminal
        this.veiculoSelected = this.terminal.idVeiculo;
        this.selectedPlate = this.vehiclesForm.find(vehicle => vehicle.id === this.terminal.idVeiculo) || null;
      } else {
        // Caso contrário, você pode zerar ou manter o valor conforme desejado
        this.veiculoSelected = null;
        this.selectedPlate = null;
      }

      this.tools.builder().spinner.hide();

      this.loadIfTerminaId();
    } catch (error) {
      this.tools.builder().spinner.hide();
      this.tools.builder().openToast.emit(error.message);
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  onSearch(filter: string) {
    if (filter) {
      const filterValue = filter.toLowerCase();
      this.filteredVehicles = this.vehiclesForm.filter(vehicle =>
        vehicle.cdPlaca.toLowerCase().includes(filterValue)
      );
    } else {
      this.filteredVehicles = [];
    }
  }

  onOptionSelected(event: any) {
    this.selectedPlate = event.option.value;
    this.veiculoSelected = this.selectedPlate.id; // Atualiza a variável com o ID do veículo selecionado
    console.log(this.veiculoSelected)
  }

  public async register(): Promise<void> {
    this.tools.builder().spinner.show();

    try {
      // Valida se o terminal já existe antes de criar (validação global, independente de empresa/divisão)
      const payload = this.buildPayload();
      const numeroTerminal = payload.numeroTerminal;

      try {
        const existingTerminal = await this.serviceCore.get<any>({
          url: `v2/terminals/find-by-numero`,
          params: {
            numeroTerminal: numeroTerminal
          }
        });

        // Terminal já existe e está ativo
        this.tools.builder().spinner.hide();
        
        const result = await Swal.fire({
          icon: "warning",
          title: "Terminal já cadastrado",
          html: `<h6>O terminal com número <strong>${numeroTerminal}</strong> já está cadastrado e ativo.</h6><p>Deseja editar este terminal?</p>`,
          showCloseButton: false,
          showCancelButton: true,
          reverseButtons: false,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sim, editar",
          focusConfirm: false,
        });

        if (result.isConfirmed && existingTerminal?.id) {
          // Redireciona para a tela de edição
          this.tools.builder().router.navigate([`/terminal/edit/${existingTerminal.id}`]);
        }
        
        return;
      } catch (checkError) {
        // Terminal não existe ou erro na verificação, continua com o cadastro normal
        if (checkError.status === 404) {
          // Terminal não existe, pode criar normalmente
        } else {
          // Erro inesperado na verificação, continua mesmo assim
          console.warn("Erro ao verificar terminal existente:", checkError);
        }
      }

      // Cria o terminal normalmente
      await this.serviceCore.post<any>(
        `v2/terminals?userId=${USER_DATA().userId}`,
        payload
      );

      this.tools.builder().spinner.hide();

      this.tools.builder().router.navigate(["/terminal"]);
    } catch (error) {
      this.tools.builder().spinner.hide();
      this.tools.builder().openToast.emit(error.message);

      this.errorMessage = error.message;

      throw new EvalError(error);
    }
  }

  public async update() {
    let paylpod: any = null;
    
    try {
      this.tools.builder().spinner.show();

      const id = Math.floor(this.terminalId);
      paylpod = this.buildPayloadEdit();
      console.log(paylpod);
      paylpod["id"] = id;

      await this.serviceCore.patch<any>(
        `${this.terminalId}?userId=${USER_DATA().userId}`,
        `v2/terminals/`,
        paylpod
      );
      this.tools.builder().spinner.hide();
      this.tools.builder().router.navigate(["/terminal"]);
    } catch (error) {
      this.tools.builder().spinner.hide();
      
      // Verifica se é erro de número de terminal duplicado
      const errorMessage = error.message || "";
      const errorLower = errorMessage.toLowerCase();
      const isDuplicateError = (errorLower.includes("numero_terminal") || 
                                errorLower.includes("número do teminal") ||
                                errorLower.includes("número do terminal")) && 
                               (errorLower.includes("já existe") || 
                                errorLower.includes("já cadastrado"));
      
      if (isDuplicateError && paylpod) {
        // Extrai o número do terminal do payload
        const numeroTerminal = paylpod?.numeroTerminal;
        
        if (numeroTerminal) {
          try {
            // Busca o terminal existente pelo número
            const existingTerminal = await this.serviceCore.get<any>({
              url: `v2/terminals/find-by-numero`,
              params: {
                numeroTerminal: numeroTerminal
              }
            });

            // Mostra pop-up perguntando se deseja editar
            const result = await Swal.fire({
              icon: "warning",
              title: "Terminal já cadastrado",
              html: `<h6>O terminal com número <strong>${numeroTerminal}</strong> já está cadastrado e ativo.</h6><p>Deseja editar este terminal?</p>`,
              showCloseButton: false,
              showCancelButton: true,
              reverseButtons: false,
              cancelButtonText: "Cancelar",
              confirmButtonText: "Sim, editar",
              focusConfirm: false,
            });

            if (result.isConfirmed && existingTerminal?.id) {
              // Redireciona para a tela de edição do terminal existente
              this.tools.builder().router.navigate([`/terminal/edit/${existingTerminal.id}`]);
            }
            
            return;
          } catch (checkError) {
            // Erro ao buscar terminal, mostra erro padrão
            console.warn("Erro ao buscar terminal existente:", checkError);
          }
        }
      }
      
      // Se não for erro de duplicação ou não conseguir tratar, mostra erro padrão
      this.errorMessage = error.message;
      this.tools.builder().openToast.emit(error.message);
      throw new EvalError(error);
    }
  }

  /* functions */

  public changeCompany() {
    console.log(this.empresaSelected);
    var idEmpresa = this.empresaSelected;

    if (this.empresaSelected == this.terminal?.idEmpresa && this.activedEdit) {
      this.filterVehiclesWhenEdit();
      this.swal = true;
      return;
    }

    this.loadVehicles(idEmpresa);
    //this.filterVehicles();
    this.swal = true;
  }

  public changeCompanyEdit() {
    var idEmpresa = this.empresaSelectedEdit;

    if (
      this.empresaSelectedEdit == this.terminal?.idEmpresa &&
      this.activedEdit
    ) {
      this.filterVehiclesWhenEdit();
      this.swal = true;
      return;
    }

    this.loadVehicles(idEmpresa);
    //this.filterVehicles();
    this.swal = true;
  }

  private async loadVehicles(empresa: any) {
    try {
      this.filteredVehicles = [];
      this.veiculoSelected = null;
      this.selectedPlate = null;
      var vehicles;

      if (empresa.cnpj != null) {
        vehicles = await this.apiBaseService.get<any>({
          url: "veiculos/getAllWithoutTerminal",
          params: {
            idEmpresa: empresa.id,
          },
        });
      } else {
        vehicles = await this.apiBaseService.get<any>({
          url: "veiculos/getAllWithoutTerminal",
          params: {
            idDivisao: empresa.id,
          },
        });
      }

      if (vehicles.length != 0) {
        this.vehiclesForm = vehicles;
        this.filteredVehicles = vehicles;
      } else {
        this.vehiclesForm = vehicles;
        this.filteredVehicles = vehicles;
        this.msgSwalWarning();
      }
    } catch (error) {
      this.tools.builder().spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  private loadIfTerminaId() {
    this.fillUserData();

    if (this.activedView) {
      this.setValuesInFormGroupLoadInView();
    } else {
      this.setValuesInFormGroupLoad();

      if (this.activedClone) {
        this.filterVehicles();
      }

      if (this.activedEdit) {
        //this.filterVehiclesWhenEdit();
      }
    }

    // Ajusta o estado do campo Número Terminal conforme o Modelo selecionado
    const numeroTerminalCtrl = this.terminalForm.get('numeroTerminal');
    if (numeroTerminalCtrl) {
      if (this.trackerModelSelected) {
        numeroTerminalCtrl.enable();
      } else {
        numeroTerminalCtrl.disable();
      }
    }

    // Ajusta os validadores conforme o modelo
    this.refreshNumeroTerminalValidators();

    // Campo RFID é exibido/aplicado apenas para modelos IStartek
    this.syncRfidEventTypeState();
  }

  public fillUserData(): void {
    this.trackerModelSelected = this.getSelectedTrackerModel();
    this.terminalProtocoloSelected = this.terminal?.idTerminalProtocolo;
    this.empresaSelected = this.terminal?.idEmpresa;
    this.veiculoSelected = this.terminal?.idVeiculo;
  }

  public isIStartekModel(model?: TrackerModel): boolean {
    const name = (model?.modelName || "").toString().trim().toUpperCase();
    return this.ISTARTEK_MODEL_NAMES.has(name);
  }

  private syncRfidEventTypeState(): void {
    const ctrl = this.terminalForm?.get("rfidEventType");
    if (!ctrl) {
      return;
    }

    const shouldEnable = this.isIStartekModel(this.trackerModelSelected);
    if (shouldEnable) {
      ctrl.enable({ emitEvent: false });
      ctrl.setValidators([Validators.required]);

      const value = (ctrl.value || "").toString().trim();
      if (!value) {
        ctrl.setValue("PASSENGER", { emitEvent: false });
      }
    } else {
      ctrl.clearValidators();
      ctrl.reset(null, { emitEvent: false });
      ctrl.disable({ emitEvent: false });
    }

    ctrl.updateValueAndValidity({ emitEvent: false });
  }

  private getSelectedTrackerModel(): TrackerModel {
    return this.trackerModelsPaginated.content.find(
      (f) => f.uuid == this.terminal?.trackerModelUuid
    );
  }

  public setFormValuesDefault() {
    this.terminalForm.controls["minutoAlarmeParada"].setValue("10");
    this.terminalForm.controls["minutoAlarmePontoMorto"].setValue("10");
    this.terminalForm.controls["fusoHorarioEnum"].setValue("0");
    this.terminalForm.controls["fusoHorario"].setValue("GMT");
    this.terminalForm.controls["fusoHorarioExibicao"].setValue("GMT-03:00");
    this.terminalForm.controls["rfidEventType"].setValue("PASSENGER");
    // Desabilita o campo Número Terminal até que um Modelo seja selecionado
    const numeroTerminalCtrl = this.terminalForm.get('numeroTerminal');
    if (numeroTerminalCtrl) {
      numeroTerminalCtrl.disable();
    }
    // Campo RFID só é habilitado quando o modelo é IStartek
    this.syncRfidEventTypeState();
  }

  public filterVehicles(): void {
    if (this.vehicles.length > 0) {
      this.vehiclesForm = this.vehicles.filter(
        (option: any) =>
          option.idEmpresa == this.empresaSelected && !option.terminalId
      );
    }

    if (!this.vehiclesForm.length) {
      if (
        this.terminal?.idEmpresa != this.empresaSelected &&
        this.activedEdit
      ) {
        this.veiculoSelected = 0.1;
        this.vehiclesForm = [NO_SELECTED_COMPANY];
      } else {
        if (this.activedEdit) {
          this.filterVehiclesWhenEdit();
        }
      }

      if (!this.activedEdit) {
        this.veiculoSelected = 0.1;
        this.vehiclesForm = [NO_SELECTED_COMPANY];
      }

      this.msgSwalWarning();
    }
  }

  public filterVehiclesWhenEdit(): void {
    if (this.vehicles.length > 0) {
      this.vehiclesForm = [
        this.vehicles
          .filter((option: any) => option.idEmpresa == this.empresaSelected)
          .find((e) => e.id == this.veiculoSelected),
      ].map((e) => {
        e["id"] = Number(e["id"]);

        return e;
      });
    }

    if (!this.vehiclesForm.length) {
      this.veiculoSelected = 0.1;
      this.vehiclesForm = [NO_SELECTED_COMPANY];
    }
  }

  public verifyVehicle(close?) {
    if (close) {
      if (
        this.terminal?.idVeiculo == this.veiculoSelected &&
        this.activedEdit
      ) {
        this.filterVehiclesWhenEdit();
      }
    } else {
      setTimeout(() => {
        this.filterVehicles();
      }, 100);
    }
  }

  public verifyIfLoadTerminalById() {
    if (this.terminalId) {
      this.loadTerminal(this.terminalId);
    }
  }

  private setValuesInFormGroupLoad() {
    FIELDS.forEach((element) => {
      if (element == "conectado" || element == "instalado") {
        this.terminalForm.controls[element].setValue(
          FormateDate.formateDate(this.terminal[element])
        );
      } else {
        this.terminalForm.controls[element].setValue(this.terminal[element]);
      }
    });

    // Carrega os valores dos novos campos de fuso horário
    if (this.terminal.fusoHorario) {
      this.terminalForm.controls["fusoHorario"].setValue(this.terminal.fusoHorario);
    }
    if (this.terminal.fusoHorarioExibicao) {
      this.terminalForm.controls["fusoHorarioExibicao"].setValue(this.terminal.fusoHorarioExibicao);
    }
  }

  private setValuesInFormGroupLoadInView() {
    FIELDS.forEach((element) => {
      switch (element) {
        case "idEmpresa":
          const company = this.companys.filter(
            (c) => c?.id == this.terminal[element]
          )[0];
          this.terminalForm.controls[element].setValue(company?.nmNome);
          return;

        case "idTerminalIcone":
          const icon = this.terminalIcons.filter(
            (c) => c?.id == this.terminal[element]
          )[0];
          this.terminalForm.controls[element].setValue(icon?.nmNome);
          return;

        case "idTerminalProtocolo":
          const protocol = this.terminalProtocols.filter(
            (c) => c?.id == this.terminal[element]
          )[0];
          this.terminalForm.controls[element].setValue(protocol?.nmNome);
          return;

        case "idVeiculo":
          const vehicle = this.vehicles.filter(
            (c) => c?.id == this.terminal[element]
          )[0];
          this.terminalForm.controls[element].setValue(vehicle?.cdPlaca);
          return;

        default:
          if (element == "conectado" || element == "instalado") {
            this.terminalForm.controls[element].setValue(
              FormateDate.formateDate(this.terminal[element])
            );
          } else {
            this.terminalForm.controls[element].setValue(
              this.terminal[element]
            );
          }

          break;
      }
    });

    // Carrega os valores dos novos campos de fuso horário
    if (this.terminal.fusoHorario) {
      this.terminalForm.controls["fusoHorario"].setValue(this.terminal.fusoHorario);
    }
    if (this.terminal.fusoHorarioExibicao) {
      this.terminalForm.controls["fusoHorarioExibicao"].setValue(this.terminal.fusoHorarioExibicao);
    }
  }

  /* utils */

  public buildPayload() {
    const vheicle = this.vehiclesForm.find(
      ({ id }) => Number(id) == Number(this.veiculoSelected)
    );

    if (this.empresaSelected.cnpj != null) {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idEmpresa: this.empresaSelected.id,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    } else {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idDivisao: this.empresaSelected.id,
        idEmpresa: null,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    }
  }

  public buildPayloadEdit() {
    const vheicle = this.vehiclesForm.find(
      ({ id }) => Number(id) == Number(this.veiculoSelected)
    );

    console.log(this.empresaSelected);

    console.log(this.empresaSelectedEdit);

    if (
      this.empresaSelectedEdit != undefined ||
      this.empresaSelectedEdit != null
    ) {
      return this.converterCompanyOrDivisionNew(
        this.empresaSelectedEdit,
        vheicle
      );
    } else {
      return this.converterCompanyOrDivision(this.empresaSelected, vheicle);
    }
  }

  public converterCompanyOrDivisionNew(companyOrDivision: any, vheicle: any) {
    if (companyOrDivision.cnpj != null) {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idEmpresa: companyOrDivision.id,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    } else {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idDivisao: companyOrDivision.id,
        idEmpresa: null,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    }
  }

  public converterCompanyOrDivision(companyOrDivision: any, vheicle: any) {
    if (this.terminal.idDivisao != null) {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idEmpresa: companyOrDivision.id,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    } else {
      const payload: any = {
        ...this.terminalForm.value,
        idTerminalProtocolo: this.trackerModelSelected.legacyProtocolId,
        trackerModelUuid: this.trackerModelSelected.uuid,
        idDivisao: companyOrDivision.id,
        idEmpresa: null,
        idTerminalIcone: parseInt(
          this.terminalForm.controls["idTerminalIcone"].value
        ),
        idVeiculo: this.veiculoSelected,
        placa: vheicle.cdPlaca,
      };
      if (!this.isIStartekModel(this.trackerModelSelected)) {
        delete payload.rfidEventType;
      }
      return payload;
    }
  }

  public numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }

    return true;
  }

  public onFusoHorarioExibicaoChange(event: any): void {
    const fusoHorarioExibicao = event.target.value;
    let fusoHorarioEnum = '0'; // Default para GMT-03:00

    switch (fusoHorarioExibicao) {
      case 'GMT-03:00':
        fusoHorarioEnum = '0';
        break;
      case 'GMT-04:00':
        fusoHorarioEnum = '1';
        break;
      case 'GMT-05:00':
        fusoHorarioEnum = '2';
        break;
      case 'GMT':
        fusoHorarioEnum = '3';
        break;
      case 'GMT+01:00':
        fusoHorarioEnum = '4';
        break;
      case 'GMT+02:00':
        fusoHorarioEnum = '5';
        break;
      case 'GMT+03:00':
        fusoHorarioEnum = '6';
        break;
    }

    this.terminalForm.get('fusoHorarioEnum').setValue(fusoHorarioEnum);
  }

  // Dispara quando o usuário escolhe o Modelo no select
  public onTrackerModelSelected(model: TrackerModel): void {
    this.trackerModelSelected = model;
    const numeroTerminalCtrl = this.terminalForm.get('numeroTerminal');
    if (numeroTerminalCtrl) {
      if (model) {
        numeroTerminalCtrl.enable();
      } else {
        numeroTerminalCtrl.disable();
      }
    }

    // Ajusta os validadores quando o modelo é selecionado
    this.refreshNumeroTerminalValidators();

    // Ajusta o campo RFID conforme o modelo selecionado
    this.syncRfidEventTypeState();
  }

  // Valida dinamicamente o Número do Terminal conforme o modelo selecionado
  public onNumeroTerminalInput(): void {
    this.refreshNumeroTerminalValidators();
  }

  private refreshNumeroTerminalValidators(): void {
    const ctrl = this.terminalForm?.get('numeroTerminal');
    if (!ctrl) { return; }

    const base = [Validators.required, Validators.minLength(15), Validators.maxLength(15)];
    const modelName = (this.trackerModelSelected?.modelName || '').toString().toUpperCase();
    if (modelName.includes('STR-CAM')) {
      base.push(Validators.pattern(/^866.*/));
    }

    ctrl.setValidators(base);
    ctrl.updateValueAndValidity();
  }

  public msgSwalWarning() {
    if (this.swal && this.empresaSelected) {
      Swal.fire({
        icon: "warning",
        title: "Aviso",
        html: `<h6> ${VHEICLE_WITHOUT_TERMINAL_NOT_FOUND_MSG} </h6>`,
        showCloseButton: false,
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonText: "Entendi",
        showConfirmButton: true,
        confirmButtonText: "Cadastrar novo veículo",
        focusConfirm: false,
      }).then((action) => {
        if (action.isConfirmed) {
          this.tools.builder().router.navigate(["/vehicles/create"]);
        }

        this.swal = false;
      });
    }
  }

  public msgSwalWarningEdit() {
    Swal.fire({
      icon: "warning",
      title: "Aviso",
      html: `<h6> ${VHEICLE_WITHOUT_TERMINAL_NOT_FOUND_MSG} </h6>`,
      showCloseButton: false,
      showCancelButton: true,
      reverseButtons: false,
      cancelButtonText: "Entendi",
      showConfirmButton: true,
      confirmButtonText: "Cadastrar novo veículo",
      focusConfirm: false,
    }).then((action) => {
      if (action.isConfirmed) {
        this.tools.builder().router.navigate(["/vehicles/create"]);
      }

      this.swal = false;
    });
  }

  public filterCompany() {
    var idEmpresa = this.empresaFilterSelected;
    var empresas = [];

    if (idEmpresa == "Divisão") {
      this.companys.forEach((element) => {
        if (element.cnpj == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Matriz") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz == null) {
          empresas.push(element);
        }
      });
    }

    if (idEmpresa == "Filial") {
      this.companys.forEach((element) => {
        if (element.cnpj != null && element.idEmpresaMatriz != null) {
          empresas.push(element);
        }
      });
    }

    this.companiesFilter = empresas;

    console.log(this.companiesFilter);
  }
}
